<app-page-top-section [title]="title" [sub_title1]="sub_title1" [sub_title2]="sub_title2"></app-page-top-section>

<!-- <div class="container">
  <div class="alert alert-danger" role="alert">
    We are currently not providing buy likes service.
    To get Likes go to Get free Likes Page

    <div class="row justify-content-center mt-4 text-center">
      <div class="col-sm-3 align-self-center mb-4">
        <button routerLink="/free-tiktok-likes" type="button" class="btn btn-primary btn-lg btn-radius">
          Get free Likes</button>
      </div>
    </div>
  </div>
</div> -->
<div *ngIf="packages != null && packages.length > 0">
  <app-select-package [packages]="packages" (packageSelected)="onPackageSelected($event)"></app-select-package>
</div>
<!-- Pricing section -->
<!-- <section class="pricing-section spad pt-0 mt-4">
  <div class="container">
    <div class="row" *ngIf="isMobile!==true; else mobileContent">
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title baby-pack">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>50 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$2.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>

            <div class="row justify-content-center">
              <button (click)="setPackageId(13)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 50 Likes</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title baby-pack">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>100 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$5.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>

            <div class="row justify-content-center">
              <button (click)="setPackageId(14)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 100 Likes</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title baby-pack">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>250 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$11.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>

            <div class="row justify-content-center">
              <button (click)="setPackageId(15)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 250 Likes</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title baby-pack">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>500 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$14.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>

            <div class="row justify-content-center">
              <button (click)="setPackageId(3)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 500 Likes</button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan gold-plan">

          <div class="pack-title beginner-plan">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>1000 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$24.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>
            <div class="row justify-content-center">
              <button (click)="setPackageId(4)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 1000 Likes</button></div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title vip-plan">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>2000 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$39.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>
            <div class="row justify-content-center">
              <button (click)="setPackageId(5)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 2000 Likes</button></div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-8 offset-md-2 offset-lg-0">
        <div class="pricing-plan">
          <div class="pack-title vip-plan">
            <div class="heart-container">
              <i class="fas fa-heart"></i>
            </div>
            <div class="plan-title">
              <div>
                <h4>5000 TikTok Likes</h4>
              </div>
            </div>
          </div>
          <div class="pricing-body">
            <h2>$74.99</h2>
            <ul>
              <li>High Quality</li>
              <li>No Password Required</li>
              <li>Shares upgrade available</li>
              <li>One Time Fee</li>
              <li>Delivery within 1-6 hours</li>
              <li>Account is 100% safe</li>
              <li>100% money back guarantee</li>
              <li>Premium Support</li>
              <li>24/7 online support</li>
            </ul>
            <div class="row justify-content-center">
              <button (click)="setPackageId(16)" type="button" class="btn btn-primary btn-lg btn-radius">
                Get 5000 Likes</button></div>
          </div>
        </div>
      </div>
    </div>

    <ng-template #mobileContent>
      <app-likes-price-mobile (setPackageId)="setPackageId($event)"></app-likes-price-mobile>
    </ng-template>
  </div>
</section> -->
<!-- Pricing section end -->


<!-- TikTok Likes - Our Handbook-->
<section class="about-section spad pt-5">
  <div class="container">
    <div class="section-title">
      <img class="section-title-icon" alt="How to Buy TikTok likes">
      <h2>Buy TikTok Likes - Our Handbook</h2>
    </div>
    <div class="row">
      <div class="col-lg-12 about-text">
        <p>The "likes" world is wide and wonderful from the psychology behind when it comes to The Oscars, Grammy and
          similar to the intergalactic glory of World Wide Web. Whilst the eye catching of the spotlight manage to
          attract people from all over to these events, the real activity and the largest array of visitors knows the
          full experience happens online. Have you ever dreamed of becoming a star? No Problem! Have a look at our
          guides and below, and lets us help you reach the top! </p>

        <h3>Our TikToks Likes Experts Tips</h3>
        <p>We want to know the thrill of stepping into a room and feeling adored, getting the love and attention makes
          you feel like a winner. Yes, as you've probably concluded its the sheer sound of applause, the thought of
          behind comfortable with who you are when standing in front of 1000's of people is what we all aim to.</p>

        <p>
          We confess we've spent hours and hours thinking. We've obsessively looked for the answer anywhere, books,
          searching online and even asked around with only one goal in mind - fulfilling our potential. During the
          process, we've shed tears. But not in vain.
        </p>

        <h3>So, Why Follow Our TikTok Likes knowhow?</h3>
        <p>Simply said and put, our TikTok Likes are like no other found on the net. They are not just for novices to
          try out, they are also for advanced TikTok users. At TikTokBlaster we don't simply tell you we will serve you
          excellent likes, we actually do it.</p>

        <h3>Why should I buy TikTok Likes?</h3>
        <ol style="padding: 0 20px 0 20px">
          <li class="bullet-text">We came to conclusion that the online world affects your life.</li>
          <li class="bullet-text">When getting likes you will benefit from seeing the reaction of your friends and learn
            more about your relationship with them.
          </li>
          <li class="bullet-text">You can enjoy the wonderful world of "social blast" from the comfort of your own home.
          </li>
          <li class="bullet-text">A good blast of TikTok likes can actually affect your life in a positive way.</li>
        </ol>
      </div>

    </div>
  </div>
</section>
<!-- TikTok Likes - Our Handbook  section end -->